import { trackEvent } from "@/lib/metaPixel";
import { openExternalUrl } from "@/lib/openExternalUrl";
import whatsAppLogo from "@/assets/whatsapp-logo.png.asset.json";

const WHATSAPP_GROUP_LINK = "https://chat.whatsapp.com/ESHM26mkIvF8AQG4RUQot9";

interface WhatsAppCTAProps {
  className?: string;
  showLabel?: boolean;
  unreadCount?: number;
  onJoined?: () => void;
}

/**
 * White pill button with the official WhatsApp mark and label.
 * Collapses to a green circle when showLabel=false (mobile floating).
 */
const WhatsAppCTA = ({ className = "", showLabel = true, unreadCount = 0, onJoined }: WhatsAppCTAProps) => {
  const base = showLabel
    ? "inline-flex items-center gap-3 rounded-full bg-white px-5 py-2 text-[#25D366] border border-[#25D366]/50 shadow-md hover:bg-[#25D366]/5 transition-colors min-h-16"
    : "inline-flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-md hover:bg-[#1ebe5d] transition-colors w-16 h-16";

  return (
    <button
      onClick={() => { void trackEvent("Contact", { content_name: "WhatsApp community" }); void openExternalUrl(WHATSAPP_GROUP_LINK); onJoined?.(); }}
      aria-label="Join FPL Managers WhatsApp Group"
      className={`relative ${base} ${className}`}
    >
      <span className={showLabel ? "relative h-12 w-12 shrink-0" : "relative h-14 w-14 shrink-0"} aria-hidden="true">
        <img src={whatsAppLogo.url} alt="" className="h-full w-full object-contain" />
      </span>
      {showLabel && (
        <span className="text-sm font-semibold whitespace-nowrap text-[#25D366]">Join Managers Chat</span>
      )}
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-500 text-[10px] font-bold text-white ring-2 ring-background">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </button>
  );
};

export default WhatsAppCTA;
